module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Italic-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Italic-webfont.ttf
// module id = 1614
// module chunks = 0